import './css/products.css';

import AnimeShapes1 from './images/products/1.jpg';
import AnimeShapes2 from './images/products/2.jpg';
import AnimeShapes3 from './images/products/3.jpg';



import {Swiper,SwiperSlide} from 'swiper/react';

import 'swiper/css';
import 'swiper/css/effect-cube';

import 'swiper/css/effect-coverflow';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import {Autoplay,EffectCube,EffectCoverflow,Navigation,Pagination} from 'swiper';





function Products(){
    return(
        <>

            

    <section className="products-category">
        <div className='container-fluid'>
            <div className="row">
                <div className="category">
                    <div className="header">
                        <h1>  مكياج أحلى ساكورا </h1> <a href="category.html"> مشاهدة الكل </a>
                    </div>

                    <div className="products">
                        <div className="slider">

                
                <Swiper  grabCursor={true} slidesPerView={'auto'} navigation={{
                nextEl: '.next-btn',
                prevEl: '.prev-btn',
                }} pagination={true}
                autoplay={{
                    delay: 3000,
                    disableOnInteraction: false,
                }}
                modules={[Autoplay,EffectCoverflow,EffectCube,Navigation,Pagination]}
                >

                


                            <SwiperSlide>


                            <div className="slide">


                                <div className="product">
                                <img src={AnimeShapes2} alt="animeproduct"/>
                                    <h1> مكياج أحلى ساكورا </h1>
                                    <div className="price">
                                        <span className="currency"> السعر </span><span>600</span> <span className="currency">س.ر</span>

                                    </div>

                                    
                                    <div className="discount">
                                        <span className="old-price">900</span>
                                        <span className="discount-range">18%</span>
                                    </div>

                                    <div className="rate">
                                        <span className="number">(46)</span>
                                        <span className="stars"><i className="fa-solid fa-star"></i>5.0</span>
                                    </div>
                                    <a href="item.html"> المزيد </a>
                                </div>


                            </div>

                            </SwiperSlide>
                            

                            

                            <SwiperSlide>


                            <div className="slide">


                                <div className="product">
                                <img src={AnimeShapes3} alt="animeproduct"/>
                                    <h1> مكياج أحلى ساكورا </h1>
                                    <div className="price">
                                        <span className="currency"> السعر </span><span>600</span> <span className="currency">س.ر</span>

                                    </div>

                                    
                                    <div className="discount">
                                        <span className="old-price">900</span>
                                        <span className="discount-range">18%</span>
                                    </div>

                                    <div className="rate">
                                        <span className="number">(46)</span>
                                        <span className="stars"><i className="fa-solid fa-star"></i>5.0</span>
                                    </div>
                                    <a href="item.html"> المزيد </a>
                                </div>


                            </div>

                            </SwiperSlide>





                            <SwiperSlide>


                            <div className="slide">


                                <div className="product">
                                <img src={AnimeShapes1} alt="animeproduct"/>
                                    <h1> مكياج أحلى ساكورا </h1>
                                    <div className="price">
                                        <span className="currency"> السعر </span><span>600</span> <span className="currency">س.ر</span>

                                    </div>

                                    
                                    <div className="discount">
                                        <span className="old-price">900</span>
                                        <span className="discount-range">18%</span>
                                    </div>

                                    <div className="rate">
                                        <span className="number">(46)</span>
                                        <span className="stars"><i className="fa-solid fa-star"></i>5.0</span>
                                    </div>
                                    <a href="item.html"> المزيد </a>
                                </div>


                            </div>

                            </SwiperSlide>





                            <SwiperSlide>


                            <div className="slide">


                                <div className="product">
                                <img src={AnimeShapes2} alt="animeproduct"/>
                                    <h1> مكياج أحلى ساكورا </h1>
                                    <div className="price">
                                        <span className="currency"> السعر </span><span>600</span> <span className="currency">س.ر</span>

                                    </div>

                                    
                                    <div className="discount">
                                        <span className="old-price">900</span>
                                        <span className="discount-range">18%</span>
                                    </div>

                                    <div className="rate">
                                        <span className="number">(46)</span>
                                        <span className="stars"><i className="fa-solid fa-star"></i>5.0</span>
                                    </div>
                                    <a href="item.html"> المزيد </a>
                                </div>


                            </div>

                            </SwiperSlide>





                            <SwiperSlide>


                            <div className="slide">


                                <div className="product">
                                <img src={AnimeShapes3} alt="animeproduct"/>
                                    <h1> مكياج أحلى ساكورا </h1>
                                    <div className="price">
                                        <span className="currency"> السعر </span><span>600</span> <span className="currency">س.ر</span>

                                    </div>

                                    
                                    <div className="discount">
                                        <span className="old-price">900</span>
                                        <span className="discount-range">18%</span>
                                    </div>

                                    <div className="rate">
                                        <span className="number">(46)</span>
                                        <span className="stars"><i className="fa-solid fa-star"></i>5.0</span>
                                    </div>
                                    <a href="item.html"> المزيد </a>
                                </div>


                            </div>

                            </SwiperSlide>





                            <SwiperSlide>


                            <div className="slide">


                                <div className="product">
                                <img src={AnimeShapes1} alt="animeproduct"/>
                                    <h1> مكياج أحلى ساكورا </h1>
                                    <div className="price">
                                        <span className="currency"> السعر </span><span>600</span> <span className="currency">س.ر</span>

                                    </div>

                                    
                                    <div className="discount">
                                        <span className="old-price">900</span>
                                        <span className="discount-range">18%</span>
                                    </div>

                                    <div className="rate">
                                        <span className="number">(46)</span>
                                        <span className="stars"><i className="fa-solid fa-star"></i>5.0</span>
                                    </div>
                                    <a href="item.html"> المزيد </a>
                                </div>


                            </div>

                            </SwiperSlide>

                            <SwiperSlide>


                            <div className="slide">


                                <div className="product">
                                <img src={AnimeShapes2} alt="animeproduct"/>
                                    <h1> مكياج أحلى ساكورا </h1>
                                    <div className="price">
                                        <span className="currency"> السعر </span><span>600</span> <span className="currency">س.ر</span>

                                    </div>

                                    
                                    <div className="discount">
                                        <span className="old-price">900</span>
                                        <span className="discount-range">18%</span>
                                    </div>

                                    <div className="rate">
                                        <span className="number">(46)</span>
                                        <span className="stars"><i className="fa-solid fa-star"></i>5.0</span>
                                    </div>
                                    <a href="item.html"> المزيد </a>
                                </div>


                            </div>

                            </SwiperSlide>



                                
                </Swiper>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>






        </>
    )
}

export default Products;